/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateCustomModalDto } from '../models';
// @ts-ignore
import type { CreateQuestionConditionalModalDto } from '../models';
// @ts-ignore
import type { CustomModalDto } from '../models';
// @ts-ignore
import type { UpdateCustomModalDto } from '../models';
// @ts-ignore
import type { UpdateQuestionConditionalModalDto } from '../models';
/**
 * CustomModalsApi - axios parameter creator
 * @export
 */
export const CustomModalsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCustomModalDto} createCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerCreateCustomModal: async (createCustomModalDto: CreateCustomModalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomModalDto' is not null or undefined
            assertParamExists('customModalsControllerCreateCustomModal', 'createCustomModalDto', createCustomModalDto)
            const localVarPath = `/api/custom-modals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomModalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuestionConditionalModalDto} createQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerCreateQuestionConditionalModal: async (createQuestionConditionalModalDto: CreateQuestionConditionalModalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuestionConditionalModalDto' is not null or undefined
            assertParamExists('customModalsControllerCreateQuestionConditionalModal', 'createQuestionConditionalModalDto', createQuestionConditionalModalDto)
            const localVarPath = `/api/custom-modals/question-conditional-modals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionConditionalModalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerDeleteQuestionConditionalModal: async (questionConditionalModalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionConditionalModalId' is not null or undefined
            assertParamExists('customModalsControllerDeleteQuestionConditionalModal', 'questionConditionalModalId', questionConditionalModalId)
            const localVarPath = `/api/custom-modals/question-conditional-modals/{questionConditionalModalId}`
                .replace(`{${"questionConditionalModalId"}}`, encodeURIComponent(String(questionConditionalModalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerGetCustomModals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/custom-modals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} customModalId 
         * @param {UpdateCustomModalDto} updateCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerUpdateCustomModal: async (customModalId: string, updateCustomModalDto: UpdateCustomModalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customModalId' is not null or undefined
            assertParamExists('customModalsControllerUpdateCustomModal', 'customModalId', customModalId)
            // verify required parameter 'updateCustomModalDto' is not null or undefined
            assertParamExists('customModalsControllerUpdateCustomModal', 'updateCustomModalDto', updateCustomModalDto)
            const localVarPath = `/api/custom-modals/{customModalId}`
                .replace(`{${"customModalId"}}`, encodeURIComponent(String(customModalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomModalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {UpdateQuestionConditionalModalDto} updateQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerUpdateQuestionConditionalModal: async (questionConditionalModalId: string, updateQuestionConditionalModalDto: UpdateQuestionConditionalModalDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionConditionalModalId' is not null or undefined
            assertParamExists('customModalsControllerUpdateQuestionConditionalModal', 'questionConditionalModalId', questionConditionalModalId)
            // verify required parameter 'updateQuestionConditionalModalDto' is not null or undefined
            assertParamExists('customModalsControllerUpdateQuestionConditionalModal', 'updateQuestionConditionalModalDto', updateQuestionConditionalModalDto)
            const localVarPath = `/api/custom-modals/question-conditional-modals/{questionConditionalModalId}`
                .replace(`{${"questionConditionalModalId"}}`, encodeURIComponent(String(questionConditionalModalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionConditionalModalDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomModalsApi - functional programming interface
 * @export
 */
export const CustomModalsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomModalsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCustomModalDto} createCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerCreateCustomModal(createCustomModalDto: CreateCustomModalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerCreateCustomModal(createCustomModalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerCreateCustomModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuestionConditionalModalDto} createQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto: CreateQuestionConditionalModalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerCreateQuestionConditionalModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerDeleteQuestionConditionalModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerGetCustomModals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomModalDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerGetCustomModals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerGetCustomModals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} customModalId 
         * @param {UpdateCustomModalDto} updateCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerUpdateCustomModal(customModalId: string, updateCustomModalDto: UpdateCustomModalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerUpdateCustomModal(customModalId, updateCustomModalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerUpdateCustomModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {UpdateQuestionConditionalModalDto} updateQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId: string, updateQuestionConditionalModalDto: UpdateQuestionConditionalModalDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId, updateQuestionConditionalModalDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomModalsApi.customModalsControllerUpdateQuestionConditionalModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomModalsApi - factory interface
 * @export
 */
export const CustomModalsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomModalsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCustomModalDto} createCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerCreateCustomModal(createCustomModalDto: CreateCustomModalDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customModalsControllerCreateCustomModal(createCustomModalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateQuestionConditionalModalDto} createQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto: CreateQuestionConditionalModalDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerGetCustomModals(options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomModalDto>> {
            return localVarFp.customModalsControllerGetCustomModals(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} customModalId 
         * @param {UpdateCustomModalDto} updateCustomModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerUpdateCustomModal(customModalId: string, updateCustomModalDto: UpdateCustomModalDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customModalsControllerUpdateCustomModal(customModalId, updateCustomModalDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} questionConditionalModalId 
         * @param {UpdateQuestionConditionalModalDto} updateQuestionConditionalModalDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId: string, updateQuestionConditionalModalDto: UpdateQuestionConditionalModalDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId, updateQuestionConditionalModalDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomModalsApi - object-oriented interface
 * @export
 * @class CustomModalsApi
 * @extends {BaseAPI}
 */
export class CustomModalsApi extends BaseAPI {
    /**
     * 
     * @param {CreateCustomModalDto} createCustomModalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerCreateCustomModal(createCustomModalDto: CreateCustomModalDto, options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerCreateCustomModal(createCustomModalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateQuestionConditionalModalDto} createQuestionConditionalModalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto: CreateQuestionConditionalModalDto, options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerCreateQuestionConditionalModal(createQuestionConditionalModalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} questionConditionalModalId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId: string, options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerDeleteQuestionConditionalModal(questionConditionalModalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerGetCustomModals(options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerGetCustomModals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} customModalId 
     * @param {UpdateCustomModalDto} updateCustomModalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerUpdateCustomModal(customModalId: string, updateCustomModalDto: UpdateCustomModalDto, options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerUpdateCustomModal(customModalId, updateCustomModalDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} questionConditionalModalId 
     * @param {UpdateQuestionConditionalModalDto} updateQuestionConditionalModalDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomModalsApi
     */
    public customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId: string, updateQuestionConditionalModalDto: UpdateQuestionConditionalModalDto, options?: RawAxiosRequestConfig) {
        return CustomModalsApiFp(this.configuration).customModalsControllerUpdateQuestionConditionalModal(questionConditionalModalId, updateQuestionConditionalModalDto, options).then((request) => request(this.axios, this.basePath));
    }
}

